import _ from 'lodash';
import { isFormPrimitiveValuesObjectArray } from './isFormPrimiteValuesObjectArray';
import {
  FormInitialValues,
  FormPrimitiveValues,
  FormPrimitiveValuesArray,
  FormPrimitiveValuesObject,
} from '../typings';

export const findChangedFormValues = (
  currentValues: FormInitialValues,
  previousValues: FormInitialValues,
) => {
  let changedProps: FormInitialValues = {};

  for (const key in currentValues) {
    if (
      currentValues[key] !== null &&
      currentValues[key] !== undefined &&
      typeof currentValues[key] === 'object' &&
      Array.isArray(currentValues[key]) &&
      isFormPrimitiveValuesObjectArray(
        currentValues[key] as
          | FormPrimitiveValuesArray
          | FormPrimitiveValuesObject[],
      )
    ) {
      const currentValue = currentValues[key] as FormPrimitiveValuesObject[];
      const previousValue = previousValues[key] as FormPrimitiveValuesObject[];

      for (let i = 0; i < currentValue.length; i++) {
        changedProps = {
          ...changedProps,
          ...findChangedFormValues(currentValue[i], previousValue[i]),
        };
      }
    } else if (!_.isEqual(currentValues[key], previousValues[key])) {
      const currentVal = currentValues[key];
      const previousVal = previousValues[key];

      // Skip if this is a newly visible field with an empty/falsy value
      // This prevents auto-save loops when conditional fields become visible
      if (
        previousVal === undefined &&
        (currentVal === '' || currentVal === null || currentVal === false)
      ) {
        continue;
      }

      changedProps[key] = currentValues[key] as
        | FormPrimitiveValues
        | FormPrimitiveValuesArray;
    }
  }

  return changedProps;
};
